export default __webpack_public_path__ + "static/media/peopleGears.cf301bef.png";